import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  USER_CATEGORY_KEY,
  UserCategory,
} from '../../../../../map/user-guide/user-guide.service';

@Injectable({ providedIn: 'root' })
export class MenuPresetService {
  readonly activePreset$ = new BehaviorSubject<UserCategory>(
    (localStorage.getItem(USER_CATEGORY_KEY) as UserCategory | null) ?? 'unspecified'
  );

  setPreset(cat: UserCategory): void {
    localStorage.setItem(USER_CATEGORY_KEY, cat);
    this.activePreset$.next(cat);
  }
}
